import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { laboratoriesActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'
import { CnpjField } from '../../components/Fields'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = laboratory => {
    const { onClose, addLaboratory, editLaboratory, changeMessage } = this.props
    if (laboratory._id) {
      editLaboratory(laboratory).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addLaboratory(laboratory).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, laboratory) => {
    e.preventDefault()
    const { setLaboratoryFormTouched } = this.props

    if ((this.props.laboratoryFormErrors || {}).valid) {
      this.handleSave(laboratory)
    } else {
      setLaboratoryFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      laboratory,
      handleChangeLaboratory,
      loadingLaboratory,
      laboratoryFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('laboratorios', token)

    return (
      <div>
        <Dialog
          modalId={laboratory._id ? 'laboratorios-editar' : 'laboratorios-novo'}
          modalParams={{ registro: laboratory._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingLaboratory ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(laboratory._id ? 'laboratorios-editar' : 'laboratorios-novo') + '-title'}>
                {isReadOnly ? (
                  'Laboratorios'
                ) : (
                  <Fragment>
                    {laboratory._id ? 'Editar laboratório' : 'Cadastrar laboratório'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'laboratory-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, laboratory)
                  }}
                >
                  <FormControl
                    error={
                      !((laboratoryFormErrors.fields || {})['nome'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeLaboratory({ ...laboratory, nome: e.target.value })
                      }}
                      value={laboratory.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((laboratoryFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((laboratoryFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((laboratoryFormErrors.fields || {})['cnpj'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-cnpj">CNPJ</InputLabel>
                    <Input
                      value={laboratory.cnpj || ""}
                      fullWidth
                      onChange={e => {
                        handleChangeLaboratory({ ...laboratory, cnpj: e.target.value })
                      }}
                      id="field-cpf"
                      inputComponent={CnpjField}
                    />
                    {!((laboratoryFormErrors.fields || {})['cnpj'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((laboratoryFormErrors.fields || {})['cnpj'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'laboratory-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    laboratory: state.laboratories.laboratory,
    loadingLaboratory: state.laboratories.loadingLaboratory,
    laboratoryFormErrors: state.laboratories.laboratoryFormErrors,
    formTouched: state.laboratories.laboratoryFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(laboratoriesActions.openModal())
    },
    closeModal: () => {
      dispatch(laboratoriesActions.closeModal())
    },
    handleChangeLaboratory: laboratory => {
      dispatch(laboratoriesActions.handleChangeLaboratory(laboratory))
    },
    addLaboratory: laboratory => {
      return dispatch(laboratoriesActions.addLaboratory(laboratory))
    },
    editLaboratory: laboratory => {
      return dispatch(laboratoriesActions.editLaboratory(laboratory))
    },
    setLaboratoryFormTouched: laboratory => {
      dispatch(laboratoriesActions.setLaboratoryFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Laboratories/EditModal.js